<template>
  <Modal @close="$emit('close')" :title="title">
    <div slot="body">
      <div>
        <div class="row mb-3">
          <div class="col-md-6">
            <VueDatePicker v-model="day" :color="secCol">
              <template #activator="{ date }">
                <DropSelect
                  :date="date"
                  :type="'datePicker'"
                  :supTitle="'Día a ejecutarse'"
                  :placeholder="'Seleccione el día'"
                  :icon="'schedule'"
                />
              </template>
            </VueDatePicker>
          </div>
          <div class="col-md-6">
            <DropSelect :z-index="6" v-bind="selectDuration" />
          </div>
          <div class="col-md-6">
            <DropSelect
              :type="'timePicker'"
              :supTitle="'Horario de Inicio'"
              :placeholder="'Seleccione el horario'"
              :icon="'clock'"
              :z-index="5"
            />
          </div>

          <div class="col-md-6">
            <DropSelect :z-index="4" v-bind="selectGrade" />
          </div>
          <div class="col-md-6">
            <DropSelect :z-index="3" v-bind="selectCourse" />
          </div>
          <div class="col-md-6">
            <DropSelect :z-index="2" v-bind="selectStudent" />
          </div>
          <div class="col-md-6">
            <DropSelect v-bind="selectBook" />
          </div>
        </div>

        <div class="row my-5">
          <div class="col-6"></div>
        </div>
        <div class="row ">
          <div class="col-lg-6 mx-auto text-center">
            <button class="button primary" @click="$emit('close')">
              Crear
            </button>
          </div>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/Modal";
import DropSelect from "@/components/DropSelect";

export default {
  name: "Work1To1Modal",
  components: {
    Modal,
    DropSelect,
  },

  data() {
    let { secCol } = this.$store.getters;

    return {
      title: "Defina los parámetros del trabajo 1 a 1",
      day: null,
      secCol,
      selectTime: null,
      selectCourse: {
        id: "course",
        supTitle: "Curso o Sección",
        placeholder: "Elige el curso o sección",
        selected: "",
        icon: "graduation-hat",
        options: [
          {
            text: "Curso 1",
            value: "1",
          },
          {
            text: "Curso 2",
            value: "2",
          },
          {
            text: "Curso 3",
            value: "3",
          },
        ],
      },
      selectDuration: {
        id: "duration",
        supTitle: "Duración",
        placeholder: "Selecciona la duración",
        selected: "",
        icon: "stopwatch",
        options: [
          {
            text: "10 minutos",
            value: "1",
          },
          {
            text: "20 minutos",
            value: "2",
          },
          {
            text: "30 minutos",
            value: "3",
          },
        ],
      },
      selectStudent: {
        id: "student",
        supTitle: "Alumno",
        placeholder: "Selecciona un alumno",
        selected: "",
        icon: "book-reader",
        options: [
          {
            text: "Edgar",
            value: "1",
          },
          {
            text: "Jorge",
            value: "2",
          },
          {
            text: "Luis",
            value: "3",
          },
        ],
      },
      selectGrade: {
        id: "grade",
        supTitle: "Nivel o Grado",
        placeholder: "Elije Nivel o Grado",
        selected: "",
        icon: "award",
        options: [
          {
            text: "Nivel 1",
            value: "1",
          },
          {
            text: "Nivel 2",
            value: "2",
          },
          {
            text: "Nivel 3",
            value: "3",
          },
        ],
      },
      selectBook: {
        id: "book",
        supTitle: "Libro",
        placeholder: "selecciona un libro",
        selected: "",
        icon: "book-open",
        options: [
          {
            text: "Rapunzel",
            value: "1",
          },
          {
            text: "Cenicienta",
            value: "2",
          },
          {
            text: "Caperucita",
            value: "3",
          },
        ],
      },
    };
  },
};
</script>
